<template lang="html">
  <section class="m-simple_modal" v-if="isDisplay">
    <div class="m-simple_modal__content">
      <main>
        <div>{{ message }}</div>
      </main>
      <footer class="m-group-btns">
        <button
          v-if="cancelText"
          class="m-button neutral"
          v-on:click="onCancelClick"
        >
          {{ cancelText }}
        </button>
        <button v-if="okText" class="m-button brand" v-on:click="onOkClick">
          {{ okText }}
        </button>
      </footer>
    </div>
  </section>
</template>

<script lang="js">

  export default  {
    name: "simple-modal",
    props: {
      message: {
        type: String,
        default: "Simple Modal"
      },
      cancelText: {
        type: String
      },
      okText: {
        type: String,
        default: "OK"
      },
      show: {}
    },
    watch: {
      show: function() {
        this.isDisplay = this.show;
      }
    },
    data () {
      return {
        isDisplay: false
      }
    },
    methods: {
      onCancelClick() {
        /**
         * Triggers delete event
         */
        const EVENT = "on-simple-modal-cancel";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, {});
        }
      },
      onOkClick() {
        /**
         * Triggers OK event
         */
        const EVENT = "on-simple-modal-ok";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, {});
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-simple_modal {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 10;
    .m-simple_modal__content {
      @include mixin-box;
      padding: 15px;
      background-color: #fff;
      margin: 20% calc((100% - 480px) / 2);
      max-width: 500px;
      position: relative;
      main {
        min-height: 30px;
        margin-bottom: 10px;
      }
      footer {
        text-align: right;
      }
    }
  }
</style>
